<template>
  <div class="home"
       :class="langFlag ?'enPage':''">
    <div :class="bgFlag?'tarnsf':''">
      <div class="hheader"
           :class="moveFlag?'bgColor':''">
        <h1 class="ihed_h1"
            @click="toHome()">
          <img src="~@/assets/images/svg/logo_top_white.svg"
               v-show="!bgFlag"
               class="logo_pic" />
          <img src="~@/assets/images/svg/logo_top_black.svg"
               class="logo_pic"
               v-show="bgFlag" />
        </h1>
        <div class="herg">
          <span class="herg_lang"
                @click='changeLang()'>{{lang}}</span>
          <i class="herg_mu"
             @click="nuneClick(1)"></i>
        </div>
      </div>
    </div>

    <div class="swiper-container home_swiper">
      <div class="swiper-wrapper">
        <!-- <div class="swiper-slide"
             :style="{backgroundImage:`url(${pic1})`}">
        </div> -->
        <div class="swiper-slide">
          <van-image width="100vw"
                     height="100vh"
                     fit="cover"
                     :src="pic1"
                     class="hm_banner">
            <template v-slot:loading>
              <van-loading type="spinner"
                           size="0" />
            </template>

          </van-image>
        </div>
        <div class="swiper-slide">'
          <van-image width="100vw"
                     height="100vh"
                     fit="cover"
                     :src="pic2"
                     class="hm_banner">
            <template v-slot:loading>
              <van-loading type="spinner"
                           size="0" />
            </template>
          </van-image>
          <!-- <div class="hvde"
               @click="toPlay">
            <img src="~@/assets/images/play_ico.png"
                 class="play_ico" />
            <video ref="videoPlayer"
                   :src=fileUrl
                   controlslist="nodownload"
                   muted
                   style="width: 100%; height: 100%; object-fit: cover">
            </video>
          </div> -->
        </div>
        <div class="swiper-slide">
          <van-image width="100vw"
                     height="100vh"
                     fit="cover"
                     :src="pic3"
                     class="hm_banner">
            <template v-slot:loading>
              <van-loading type="spinner"
                           size="0" />
            </template>
            <!-- <template v-slot:loading>
              <van-loading type="spinner"
                           size="40" />
            </template> -->
          </van-image>
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>
      <!-- 如果需要导航按钮 -->
      <!-- <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div> -->

    </div>
    <div class="hocon">
      <p class="hocon_tit pcTit">DESIGN FOR EYES AND HEARTS</p>
      <p class="hocon_tit wapTit">DESIGN</br> FOR </br>EYES</br> AND </br>HEARTS</p>

      <div class="hocon_bd">
        <div class="hocom_item clearfix"
             v-for="(item,index) in goodsList"
             :key="item.id">
          <div class="hcom_tp "
               :class="index%2== 0 ?'right':'left'">
            <van-image :src="item.pic2"
                       class="m_pic"></van-image>
            <van-image :src="item.pic"
                       class="hm_pic"></van-image>
            <!-- 
            <img :src="item.pic"
                 class="hm_pic" />

            <img :src="item.pic2"
                 class="m_pic" /> -->
          </div>
          <div class="hcom_wz  "
               :class="index%2== 0 ?'left':'right'">
            <p class="hcom_p1 fontS">{{item.title}}</p>
            <p class="hcom_p2"
               v-html="item.desp">{{}}</p>
            <span class="hcom_btn"
                  @click="toGoodsDetail(item.id)">{{langFlag ?'View Project':'浏览作品' }}</span>

          </div>

        </div>
        <!-- <div class="hocom_item clearfix">
          <div class="hcom_tp left">
            <img src="~@/assets/images/home/hm_pic2.jpg"
                 class="hm_pic" />
            <img src="~@/assets/images/m_pic2.jpg"
                 class="m_pic" />
          </div>
          <div class="hcom_wz right zwPage">
            <p class="hcom_p1">酒店设计</p>
            <p class="hcom_p2">依托理想国西川4公里沿河景致的生态资源，紧邻西川的西5苑下叠户型
              为住宅空间打造提供了丰富的自然环境。整个项目设计意在放大空间尺
              度，公共区域采用“去中心化”的设计手法，让各个功能区有机串联，启发
              “无边界”的生活方式。</p>
            <span class="hcom_btn">View Project</span>
          </div>
          <div class="hcom_wz right ywPage">
            <p class="hcom_p1">Hotel & Resort</p>
            <p class="hcom_p2">We have a growing portfolio of furniture and
              objects, which bring our values to life in three
              dimensional form. We work hand in hand with
              manufacturers and craftspeople to understand
              all aspects of materials, skills and production.</p>
            <span class="hcom_btn">View Project</span>
          </div>

        </div>
        <div class="hocom_item clearfix">
          <div class="hcom_tp right">
            <img src="~@/assets/images/home/hm_pic3.jpg"
                 class="hm_pic" />
            <img src="~@/assets/images/m_pic3.jpg"
                 class="m_pic" />
          </div>
          <div class="hcom_wz left zwPage">
            <p class="hcom_p1">住宅设计</p>
            <p class="hcom_p2">项目通过设计将远行的旅人、来公园游玩的路人，以及居住在此处的
              邻里相联，强化三者对空间高度重叠和互补的共同需求。在形态上，
              让室内外得到更大流动的开放空间，塑造出“城市客厅”的亲切姿态。</p>
            <span class="hcom_btn">浏览作品</span>
          </div>
          <div class="hcom_wz left ywPage">
            <p class="hcom_p1">Residential</p>
            <p class="hcom_p2">We work on homes of all shapes and sizes all
              over the world. From new builds to renovations, city apartments to mountain retreats,
              our approach is always to understand our
              clients and create a home that nurtures and
              supports their needs.</p>
            <span class="hcom_btn">View Project</span>
          </div>
        </div> -->
      </div>
      <gotop></gotop>
      <!-- footer -->
      <!-- footer -->
      <foot @contact="contact"></foot>
      <transition name="slide-fade">
        <munePage v-show="muneFlag"
                  :muneFlag="muneFlag"
                  :muneIndex="muneIndex"
                  @closeMu="closeMu"
                  @muneChange='muneIndexChange'></munePage>
      </transition>
    </div>
    <!-- 视频弹窗 begin -->
    <transition name="slide-fade">
      <div class="vdDailog"
           v-show="vdFlag">
        <div class="vdDailog_mask"
             @click="vdFlag = false"></div>
        <div class="vdDailog_con">
          <video ref="videoPlayer2"
                 controls
                 preload="auto"
                 webkit-playsinline="true"
                 playsinline="true"
                 x5-video-player-type="h5"
                 x5-video-player-fullscreen="true"
                 x-webkit-airplay="allow"
                 x5-video-orientation="portraint"
                 :src=fileUrl
                 @play="toPlay"
                 @pause="toPause"
                 style="width: 100%; height: 100%; object-fit: contain">
          </video>
        </div>
      </div>
    </transition>
    <!-- 视频弹窗 end -->
  </div>
</template>

<script>
import Vue from 'vue'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min.js'
import foot from '@/components/foot.vue'
import gotop from '@/components/goTop.vue'
import munePage from '@/pages/munePage.vue'
import { mapMutations, mapGetters, mapState } from 'vuex'
import { Lazyload } from 'vant'
import { Image as VanImage } from 'vant'
Vue.use(VanImage)
Vue.use(Lazyload)
export default {
  data() {
    return {
      bgFlag: false,
      vdFlag: false,
      muneFlag: false,
      muneIndex: -1,
      mySwiper: null,
      // img1: require('@/assets/images/home/hm_banner.jpg'),
      moveFlag: false,
      fileUrl: require('@/assets/images/v.mp4'),
      goodsList: [],
      pic1: require('@/assets/images/home/hm_banner.jpg'),
      pic2: require('@/assets/images/home/hm_banner.jpg'),
      pic3: require('@/assets/images/home/hm_banner.jpg'),
    }
  },
  components: { foot, gotop, munePage },
  computed: {
    ...mapState(['langFlag', 'lang', 'title']),
  },
  mounted() {
    let that = this

    // 滚动条滚动
    window.addEventListener('scroll', this.handleScroll)
    this.projectCate()
    this.homeSwiper()
  },

  watch: {
    langFlag(val) {
      console.log('中英文的值', val)
      this.projectCate()
      this.homeSwiper()
    },
    title(val) {
      document.title = val
    },
  },
  methods: {
    // ...mapMutations(['SET_WFFLAG']),

    //  视频播放
    toPlay() {
      this.vdFlag = true
      this.$refs.videoPlayer2.play()
      // this.$refs.videoPlayer.paused === true
      //   ? this.$refs.videoPlayer.play()
      //   : this.$refs.videoPlayer.pause()
    },
    toPause() {
      // this.$refs.videoPlayer.paused === true
      //   ? this.$refs.videoPlayer.pause()
      //   : this.$refs.videoPlayer.pause()
    },

    // 菜单
    nuneClick(index) {
      this.muneFlag = true
      this.muneIndex = -1
    },
    closeMu() {
      this.muneFlag = false
    },
    contact() {
      this.muneFlag = true
      this.muneIndex = 3
    },
    muneIndexChange(index) {
      this.muneIndex = index
    },
    handleScroll() {
      // 页面滚动距顶部距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var winH =
        document.documentElement.clientHeight || document.body.clientHeight
      var scroll = scrollTop - this.i
      this.i = scrollTop
      if (scroll <= 0) {
        this.moveFlag = false
      } else {
        this.moveFlag = true
      }
      if (scrollTop < winH) {
        this.bgFlag = false
      } else {
        this.bgFlag = true
      }

      // let t1 = document.documentElement.scrollTop || document.body.scrollTop
      // if (t1 > 10) {
      //   this.moveFlag = true
      // } else {
      //   this.moveFlag = false
      // }
    },
    //切换语言
    changeLang() {
      // this.SET_WFFLAG(true)
      console.log('语言1', this.langFlag)
      this.$store.commit('setLang', !this.langFlag)
      this.$store.commit('setLa', this.lang == 'EN' ? 'CH' : 'EN')
      console.log('语言', this.langFlag)
    },

    // 获取产品分类
    projectCate() {
      let that = this
      let type = 'CN'
      if (this.langFlag) {
        //英文
        type = 'EN'
      }
      let data = this.$post(
        'projectCate',
        that.$qs.stringify({
          type: type,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            that.goodsList = response.data
            console.log('ddd', that.goodsList)
          }
        })
        .catch(function (error) {})
    },
    // 返回首页
    toHome() {
      this.$router.push({
        name: 'home',
        // query: {
        //   type: type,
        // },
      })
    },
    toGoodsDetail(id) {
      this.$router.push({
        name: 'imageList',
        query: {
          id: id,
        },
      })
    },
    // 获取网站配置
    homeSwiper() {
      let that = this
      let type = 'CN'
      if (this.langFlag) {
        //英文
        type = 'EN'
      }
      let data = this.$post(
        'settings',
        that.$qs.stringify({
          type: type,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            let info = response.data
            response.data.forEach(function (item) {
              if (item.code == 'WEB_PIC1' || item.code == 'WEB_PIC11') {
                //"首页位置1"
                that.pic1 = item.value
              } else if (item.code == 'WEB_PIC2' || item.code == 'WEB_PIC22') {
                //"首页位置2"
                that.fileUrl = item.value
                that.pic2 = item.value
              } else if (item.code == 'WEB_PIC3' || item.code == 'WEB_PIC33') {
                //首页位置3"
                that.mzname = item.value
                that.pic3 = item.value
              }
            })
            that.$nextTick(function () {
              that.mySwiper = new Swiper('.home_swiper', {
                observer: true,
                observeParents: true,
                speed: 1800,
                slidesPerView: 'auto',
                centeredSlides: true,
                loop: false,
                autoplay: {
                  delay: 5000,
                  disableOnInteraction: false,
                },
                pagination: {
                  el: '.home_swiper .swiper-pagination',
                  clickable: true,
                },
                on: {
                  slideChangeTransitionEnd: function () {
                    // alert(this.realIndex) //切换结束时，告诉我现在是第几个slide
                    if (this.realIndex == 1) {
                      // that.$refs.videoPlayer.play()
                    }
                  },
                },
              })
            })
          }
        })
        .catch(function (error) {})
    },
  },
}
</script>
<style>
/* @import './../assets/css/base.css'; */
.hvde video {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.hvde {
  position: relative;
  width: 100%;
  height: 100%;
}
.home_swiper .play_ico {
  position: absolute;
  left: 50%;
  width: 1rem !important;
  height: 1rem !important;
  margin: -0.5rem 0 0 -0.5rem;
  top: 50%;
  z-index: 10;
}
.hcom_tp .van-image__error-icon {
  min-height: 100px;
  font-size: 1rem;
}
</style>





// WEBPACK FOOTER //
// src/pages/home.vue